import React from 'react';
import MapboxMap from './MapboxMap';

// TODO: not sure we need this component, could just rename MapboxMap to Map
export const Map = () => {
  return (
    <MapboxMap />
  );
};
